import dayjs from 'dayjs';

export const formatDate = (date: string | null | undefined, withTime: boolean = false) => {
  if (!date) return date;
  return dayjs.utc(date).format('DD.MM.YYYY' + (withTime ? ' HH:mm' : ''));
};
